<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9 9.563c1.223 0 2.303.292 3.18.675.81.36 1.32 1.17 1.32 2.047V13.5h-9v-1.207c0-.885.51-1.695 1.32-2.048A7.83 7.83 0 0 1 9 9.563ZM3 9.75c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5-1.5.675-1.5 1.5.675 1.5 1.5 1.5Zm.848.825A5.237 5.237 0 0 0 3 10.5c-.743 0-1.448.158-2.085.435-.555.24-.915.78-.915 1.387V13.5h3.375v-1.207c0-.623.172-1.208.473-1.718ZM15 9.75c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5-1.5.675-1.5 1.5.675 1.5 1.5 1.5Zm3 2.572c0-.607-.36-1.147-.915-1.387A5.213 5.213 0 0 0 15 10.5c-.293 0-.57.03-.848.075.3.51.473 1.095.473 1.718V13.5H18v-1.178ZM9 4.5a2.247 2.247 0 0 1 2.25 2.25A2.247 2.247 0 0 1 9 9a2.247 2.247 0 0 1-2.25-2.25A2.247 2.247 0 0 1 9 4.5Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
